import React from "react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import ClearRoundedIcon from "@material-ui/icons/ClearRounded";
import styles from "./ViewRecordingModal.module.css";
import { ExlyDynamicVideoPlayer } from "../../../../../../../../features/Common/modules/VideoPlayer/ExlyDynamicVideoPlayer";

const ViewRecordingModal = (props) => {
  const { open, data, handleClose } = props;

  const { stream_url, streaming_platform } = data;

  return (
    <Dialog open={open} onClose={handleClose}>
      <div className={styles.video_wrapper}>
        <IconButton className={styles.clear_icon_style} onClick={handleClose}>
          <ClearRoundedIcon />
        </IconButton>
        <ExlyDynamicVideoPlayer
          videoLink={stream_url}
          videoSource={streaming_platform}
          isZoomRecording={true}
          className={"tw-w-[640px]"}
        />
      </div>
    </Dialog>
  );
};

export default ViewRecordingModal;
